// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { Box } from "@mui/material";
// import photo1 from "../../../Images/TeamPhoto/photo1.webp"
// import photo2 from "../../../Images/TeamPhoto/photo2.webp"
// import photo3 from "../../../Images/TeamPhoto/photo3.jpg"
// import "./aboutUsSilder.css"

// const images = [
//     photo1,
//     photo2,
//     photo3
// ];



// const AutoSlider = () => {
//     const settings = {
//       dots: false,
//       infinite: true,
//       speed: 1000,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       initialSlide: 0,
//       autoplay: true,
//       autoplaySpeed: 3000, // Change slide every 3 seconds
//       arrows: true, // Hide arrows if not needed'
//       className: "myCustomCarousels",
//       responsive: [
//         {
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 1,
//               slidesToScroll:   1,
//               arrows:true
//             //   infinite: true,
//             //   dots: true
//             }
//           },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           initialSlide: 1,
//           arrows:true
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows:true
//         }
//       }
//     ]
//     };
  
//     return (
//       <Box sx={{ maxWidth: "100%"}}>
//         <Slider {...settings}>
//           {images.map((img, index) => (
//             <Box key={index}  >  
//             <img
//               src={img}
//               alt={`Slide ${index + 1}`}
//               style={{ width: "100%",height:"88vh",  }}
//             />
//           </Box>
//           ))}
//         </Slider>
//       </Box>
//     );
//   };



// export default AutoSlider;


import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import photo1 from "../../../Images/TeamPhoto/photo1.webp"
import photo2 from "../../../Images/TeamPhoto/photo2.webp"
import photo3 from "../../../Images/TeamPhoto/photo3.jpg"

import './aboutUsSilder.css';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { Box } from '@mui/material';

export default function App() {
  return (
    <>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        // loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        
        <SwiperSlide style={{position:'relative',width:"100%"}}>
          <img src={photo1} style={{width:"100%",height:"85vh"}}/>
          <Box sx={{
              position: "absolute",
              zIndex: 50,
              left: 0,
              top: "50%",
              transform: "translatey(-50%)",
              textTransform: "uppercase",
              color: "white",
              letterSpacing: "0.175rem",
              height: "100%",
              background:
                "linear-gradient(82deg, rgba(0, 0, 0, 0.36) 0%, rgba(0, 0, 0, 0) 100%)",
              paddingLeft: "4rem",
              paddingTop: "20%",
              paddingRight: "10rem",
              width: "100%",
            }}></Box>
          </SwiperSlide>
          <SwiperSlide style={{position:'relative',width:"100%"}}>
          <img src={photo2} style={{width:"100%",height:"85vh"}}/>
          <Box sx={{
              position: "absolute",
              zIndex: 50,
              left: 0,
              top: "50%",
              transform: "translatey(-50%)",
              textTransform: "uppercase",
              color: "white",
              letterSpacing: "0.175rem",
              height: "100%",
              background:
                "linear-gradient(82deg, rgba(0, 0, 0, 0.36) 0%, rgba(0, 0, 0, 0) 100%)",
              paddingLeft: "4rem",
              paddingTop: "20%",
              paddingRight: "10rem",
              width: "100%",
            }}></Box>
          </SwiperSlide>
          <SwiperSlide style={{position:'relative',width:"100%"}}>
          <img src={photo3} style={{width:"100%",height:"85vh"}}/>
          <Box sx={{
              position: "absolute",
              zIndex: 50,
              left: 0,
              top: "50%",
              transform: "translatey(-50%)",
              textTransform: "uppercase",
              color: "white",
              letterSpacing: "0.175rem",
              height: "100%",
              background:
                "linear-gradient(82deg, rgba(0, 0, 0, 0.36) 0%, rgba(0, 0, 0, 0) 100%)",
              paddingLeft: "4rem",
              paddingTop: "20%",
              paddingRight: "10rem",
              width: "100%",
            }}></Box>
          </SwiperSlide>
      </Swiper>
    </>
  );
}